<div class="md:w-1/2 lg:flex lg:flex-col lg:justify-between lg:space-y-6 lg:w-1/3">
	<slot />
</div>
